<template>
  <div class="content">
    <!-- 基本信息 -->
    <div class="content-box content-scheme">
      <div class="pay-info" v-if="Object.keys(schemeInfo).length">
        <!--
          甲方代表 总部一样 显示总部应收  显示 总部应收，金额取 甲方授权代表应收金额
          甲方代表 售后一样 显示甲方代表应收 显示甲方授权代表应收 金额取 甲方授权代表应收。
          总部为售后服务公司时，售后公司应收的金额 需累计总部应收中
        -->
        <div v-if="contractInfo.partyAId !== contractInfo.hqId">
          {{ $t('crm_contract_scheme.jfsqdbys') }}：
          <span>{{ schemeInfo.firstTotal }}</span>
        </div>
        <div>
          {{ $t('crm_contract_scheme.zong_bu_ying_shou') }}:
          <span v-if="contractInfo.partyAId === contractInfo.hqId&&contractInfo.hqId !== contractInfo.afterServiceId">{{ schemeInfo.firstTotal }}</span>
          <span v-else-if="contractInfo.partyAId !== contractInfo.hqId && contractInfo.hqId === contractInfo.afterServiceId">{{ parseFloat((schemeInfo.hqProfitTotal + schemeInfo.serviceProfitTotal).toFixed(2))  }}</span>
          <span v-else-if="contractInfo.partyAId === contractInfo.hqId && contractInfo.hqId === contractInfo.afterServiceId">{{  schemeInfo.firstTotal }}</span>
          <span v-else>{{ schemeInfo.hqProfitTotal }}</span>
        </div>
        <div v-if="contractInfo.partyAId !== contractInfo.afterServiceId&& contractInfo.hqId !== contractInfo.afterServiceId">
          {{ $t('crm_contract_scheme.shou_hou_ying_shou') }}：
          <span>{{ schemeInfo.serviceProfitTotal }}</span>
        </div>
      </div>
      <div class="info">
        <!-- :default-expand-all="true" -->
        <el-table v-loading="isLoading" :data="leaseForm.contractList" style="width: 100%" :row-key="getRowKeys" :expand-row-keys="expands">
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div class="tab-wrap">
                <el-form :rules="rules" label-position="top" class="wrap-form">
                  <el-row :gutter="15" class="wrap-form-row">
                    <template v-if="scope.row.edit">
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_scheme.zu_jin_yue')">
                          <template v-if="isDiscounted(scope.row)">
                            <span class="discount-rent">{{ scope.row.currencyUnit }}{{ getFinalRent(scope.row).toFixed(2) }}</span> /
                            <del>{{ scope.row.currencyUnit }}{{ scope.row.unitPrice }}</del>
                          </template>
                          <template v-else>
                            {{ scope.row.currencyUnit }}
                            {{ scope.row.unitPrice }}
                          </template>
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_scheme.swfdjey')">
                          <el-input v-model="scope.row.discountPrice" :class="{ 'discount-price-input': isDiscounted(scope.row) }" type="number" placeholder style="width: 100%">
                            <template slot="prepend">
                              {{ scope.row.currencyUnit }}
                            </template>
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_scheme.shfjfy')">
                          <el-input v-model="scope.row.additionalFee" placeholder style="width: 100%">
                            <template slot="prepend">
                              {{ scope.row.currencyUnit }}
                            </template>
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_scheme.fu_kuan_qi_shu')">
                          {{ Math.ceil(scope.row.rentalTerm / scope.row.paymentPeriodSlef) }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_scheme.sqfcfa')">
                          {{ scope.row.sharingClass}}
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_scheme.shou_qi_zu_jin_tai')">
                          {{ scope.row.currencyUnit }}
                          {{ (getRentCost(scope.row) * scope.row.paymentPeriodSlef).toFixed(2) }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="3" @click.native="onPreviewDialog(scope.row)">
                        <el-form-item :label="$t('crm_contract_scheme.lei_ji_zu_jin_tai')" style="cursor: pointer">
                          {{ scope.row.currencyUnit }}
                          {{ (getRentCost(scope.row) * scope.row.rentalTerm).toFixed(2) }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_scheme.she_bei_shu_liang')">
                          <el-input v-model="scope.row.bookingNum" type="number" min="0" style="width: 100%"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_scheme.ya_jin_tai')">
                          <el-input v-model="scope.row.depositFee" placeholder style="width: 100%">
                            <template slot="prepend">
                              {{ scope.row.currencyUnit }}
                            </template>
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_scheme.xu_zong_bu_fa_huo')">
                          <el-input v-model="scope.row.hqDeliveryNum" type="number" style="width: 100%"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="3" v-if="!lastOrderId">
                        <!--2021-09-02 期末续租不需要设总部发货收货方 -->
                        <el-form-item :label="$t('crm_contract_scheme.zbfhshf')">
                          <custom-select disabled v-model="scope.row.hqShipTo" code="crm_receiving_party" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
                        </el-form-item>
                      </el-col>
                    </template>
                    <template v-else>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_scheme.zu_jin_yue')">
                          <template v-if="isDiscounted(scope.row)">
                            <span class="discount-rent">{{ scope.row.currencyUnit }}{{ getFinalRent(scope.row).toFixed(2) }}</span> /
                            <del>{{ scope.row.currencyUnit }}{{ scope.row.unitPrice }}</del>
                          </template>
                          <template v-else>
                            {{ scope.row.currencyUnit }}
                            {{ scope.row.unitPrice }}
                          </template>
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_scheme.swfdjey')">
                          <span class="discount-price">
                            {{ scope.row.currencyUnit }}
                            {{ getNumber(scope.row.discountPrice) }}
                          </span>
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_scheme.shfjfy')">
                          {{ scope.row.currencyUnit }}
                          {{ scope.row.additionalFee }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_scheme.fu_kuan_qi_shu')">
                          {{ Math.ceil(scope.row.rentalTerm / scope.row.paymentPeriodSlef) }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_scheme.sqfcfa')">
                          {{ scope.row.sharingClass}}
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_scheme.shou_qi_zu_jin_tai')">
                          {{ scope.row.currencyUnit }}
                          {{ (getRentCost(scope.row) * scope.row.paymentPeriodSlef).toFixed(2) }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="3" @click.native="onPreviewDialog(scope.row)">
                        <el-form-item :label="$t('crm_contract_scheme.lei_ji_zu_jin_tai')" style="cursor: pointer">
                          {{ scope.row.currencyUnit }}
                          {{ (getRentCost(scope.row) * scope.row.rentalTerm).toFixed(2) }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_scheme.she_bei_shu_liang')">
                          {{ scope.row.bookingNum }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_scheme.ya_jin_tai')">
                          {{ scope.row.currencyUnit }}
                          {{ scope.row.depositFee }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item :label="$t('crm_contract_scheme.xu_zong_bu_fa_huo')">
                          {{ scope.row.hqDeliveryNum }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="3" v-if="!lastOrderId">
                        <el-form-item :label="$t('crm_contract_scheme.zbfhshf')">
                          <custom-select disabled v-model="scope.row.hqShipTo" code="crm_receiving_party" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
                        </el-form-item>
                      </el-col>
                    </template>
                    <el-col :span="4">
                      <el-form-item :label="$t('Common.com_handle')">
                        <el-button type="text" size="mini" v-if="!scope.row.edit" @click="editItem(scope.row)">{{ $t('Common.com_edit') }}</el-button>
                        <el-button type="text" size="mini" v-if="scope.row.edit" @click="saveItem(scope.row)">{{ $t('Common.com_save') }}</el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
                <ul class="rent-amount">
                  <li>
                    <p class="titel">
                      {{ $t('crm_contract_scheme.sqljzj') }}
                    </p>
                    <p class="amount">
                      {{ scope.row.currencyUnit }}
                      <!-- 50,000.00 -->
                      {{ (getRentCost(scope.row) * scope.row.paymentPeriodSlef * scope.row.bookingNum).toFixed(2) }}
                    </p>
                  </li>
                  <li>
                    <p class="titel">
                      {{ $t('crm_contract_scheme.lei_ji_ya_jin') }}
                    </p>
                    <p class="amount">
                      {{ scope.row.currencyUnit }}
                      {{ (scope.row.depositFee * scope.row.bookingNum).toFixed(2) }}
                    </p>
                  </li>
                  <li>
                    <p class="titel">
                      {{ $t('crm_contract_scheme.shou_qi_xu_zhi_fu') }}
                    </p>
                    <p class="amount">
                      {{ scope.row.currencyUnit }}
                      {{
                        (
                          getRentCost(scope.row) * scope.row.paymentPeriodSlef * scope.row.bookingNum +
                          scope.row.depositFee * scope.row.bookingNum
                        ).toFixed(2)
                      }}
                    </p>
                  </li>
                </ul>
              </div>
            </template>
          </el-table-column>
          <!-- 配置列 -->
          <template v-for="(item, index) in tableColumn">
            <el-table-column
              v-if="item.selected"
              :key="index"
              :index="index"
              :prop="item.columnCode"
              :label="item.columnName"
              :width="item.width"
              :formatter="item.isFormat ? formatColumn : null"
              :sortable="item.isSort ? 'custom' : null"
              :fixed="item.isLock ? 'right' : null"
              show-overflow-tooltip
            ></el-table-column>
          </template>
          <!-- 操作列 -->
          <el-table-column :label="$t('Common.com_handle')" width="280" fixed="right" v-if="tableColumn.length">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="onRowExpansion(scope.row)">{{ $t('Common.com_edit') }}</el-button>
              <el-button type="text" size="mini" @click="deleteLeaseItem(scope.$index, scope.row)">{{ $t('Common.com_delete') }}</el-button>
              <el-button type="text" size="mini" @click="onPreviewDialog(scope.row)">{{ $t('crm_contract_scheme.ckfcmx') }}</el-button>
              <el-button type="text" size="mini" @click="onPreviewBreakDialog(scope.row)">{{ $t('crm_contract_scheme.ckwyfa') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-button style="margin: 15px" type="primary" @click="addBenefitSharing()">{{ $t('com_add_to') }}</el-button> -->
      </div>
      <div class="lease-add-btn" @click="addLeaseItem">
        <div style="display: inline-block">
          <i class="icon icon-add"></i>
          <span>{{ $t('crm_contract_scheme.tjsbzlxx') }}</span>
        </div>
      </div>
    </div>
    <div class="btn-group">
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button @click="preStep">{{ $t('crm_contract_scheme.sybhtxx')}}</el-button>
      <template v-if="backType === 'order'">
        <el-button type="primary" @click="saveScheme(true)">{{ $t('crm_contract_scheme.xybtxljhc') }}</el-button>
      </template>
      <template v-else>
        <!-- <el-button type="primary" @click="saveScheme">{{ $t('page_content_next_step_payment_information') }}</el-button> -->
        <el-button type="primary" @click="saveScheme(true)" v-if="contractInfo.signingMethod === 2">{{ $t('crm_contract_scheme.xybsczzht') }}</el-button>
        <el-button type="primary" @click="saveScheme(true)" v-if="contractInfo.signingMethod === 1">{{ $t('crm_contract_scheme.xybxzdzht') }}</el-button>
      </template>
    </div>
    <!-- 选择方案 -->
    <contractManagement-addLease-dialog v-if="dialogVisible" :data="dialogData" :model="dialogModel" @close="dialogVisible = false" @success="addLeaseList"></contractManagement-addLease-dialog>
    <!-- 查看分成 -->
    <step-manage-preview-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false"></step-manage-preview-dialog>
    <!-- 查看违约方案 -->
    <!-- <contract-break-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false"></contract-break-dialog> -->
    <step-manage-falsify-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false"></step-manage-falsify-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import stepManagePreviewDialog from '@/pages/crm/components/managePreviewDialog.vue';
import stepManageFalsifyDialog from '@/pages/crm/contractLeaseItem/children/step_manage_falsify_dialog';
import contractManagementAddLeaseDialog from './contractManagement_addLease_dialog.vue';
// import contractBreakDialog from './contract_scheme_break_dialog.vue';

export default {
  components: { contractManagementAddLeaseDialog, stepManagePreviewDialog, stepManageFalsifyDialog },

  props: {
    backType: { type: String, default: '' },
    lastOrderId: { type: String, default: '' },
    contractId: [String, Number],
    contractClass: [String, Number],
    operateFlag: [String, Number], // 唯一标识
  },
  inject: ['getContractInfo'],
  computed: {
    contractInfo() {
      return this.getContractInfo();
    },
  },
  watch: {
    // contractInfo: function () {
    //   // console.log(this.contractInfo);
    //   // this.setContractInfo();
    // },
  },
  data() {
    return {
      tableCode: 'contract_scheme',
      // 服务中心
      form: {},
      rules: {},
      // 获取row的key值
      getRowKeys(row) {
        return row.goodsSkuId;
      },
      expands: [],
      isLoading: false,
      // 租赁方案
      leaseForm: {
        contractList: [],
        // 删除的
        deleteList: [],
      },

      // 选择收货地址
      dialogVisible: false,
      dialogModel: {},
      dialogData: {},
      // 公司ID
      // contractId: '',

      dialogVisible1: false,
      dialogModel1: {},
      dialogVisible2: false,
      dialogModel2: {},
      // 售后公司列表
      allServiceList: [],
      leaseId: '',
      schemeInfo: {},
    };
  },
  mounted() {
    // this.factoryId = this.getJump('factoryId');
    // this.contractId = this.contractId || '';

    this.getTableColumn();
    this.getCompanyDetail();
    // this.leaseForm.contractList.push(this.leaseItem);
  },
  methods: {
    getCompanyDetail: function () {
      if (!this.contractId) {
        return;
      }
      this.isLoading = true;
      this.$getJSON(apis.crmContractListScheme, { bizId: this.contractId, bizClass: this.contractClass }).then((res) => {
        this.isLoading = false;
        const data = res.data.goodsList ? res.data.goodsList : [];
        data.forEach((i) => {
          i.edit = false;
          i.hqShipTo = i.hqShipTo ? `${i.hqShipTo}` : '2';
          // 兼容历史方案未返回商务浮动金额的情况。
          i.discountPrice = this.getNumber(i.discountPrice);
          i.discountAmount = this.getFinalRent(i).toFixed(2);
          // 如果是一次性付清 0 就改为一期
          if (i.paymentPeriod === '0' || i.paymentPeriod === 0) {
            i.paymentPeriodSlef = i.rentalTerm;
          } else {
            i.paymentPeriodSlef = i.paymentPeriod;
          }
        });
        this.leaseForm.contractList = data;
        this.schemeInfo = res.data;
      });
    },
    // 取消
    onCancel: function () {
      // this.jump('/contract/management', { refresh: true }, true);
      this.$emit('cancelJump');
    },
    // 选择方案弹窗回调
    addLeaseList: function (list, rentalTerm) {
      // productCode
      // 修复数量为空 总额NAN
      list.forEach((i) => {
        if (!i.bookingNum) {
          this.$set(i, 'bookingNum', 1);
          this.$set(i, 'hqDeliveryNum', 0);
          this.$set(i, 'edit', false);
        }
        // 设置月数
        i.rentalTerm = rentalTerm;
        // 商务浮动金额默认 0，最终租金默认等于原租金。
        i.discountPrice = this.getNumber(i.discountPrice);
        i.discountAmount = this.getFinalRent(i).toFixed(2);
        // 发货方默认是乙方
        i.hqShipTo = '2';
        // 如果是一次性付清 0 就改为一期  如果是周期超过租赁月数那就用租赁月数
        if (i.paymentPeriod === '0' || i.paymentPeriod === 0) {
          i.paymentPeriodSlef = i.rentalTerm;
        } else {
          i.paymentPeriodSlef = i.paymentPeriod;
        }
        // 加载回来默认是展开的
        i.edit = true;
      });
      // 去除重叠的方案和月数和产品编码是唯一
      const concatArr = this.leaseForm.contractList.concat(list.filter(item => !this.leaseForm.contractList.find(inItem => inItem.goodsSkuId === item.goodsSkuId && inItem.rentalTerm === item.rentalTerm && inItem.productCode === item.productCode)));
      this.leaseForm.contractList = concatArr;
      if (list) {
        this.expands = [];
        this.expands.push(list[0].goodsSkuId);
      }

      // this.onRowExpansion(list);
    },

    // 租赁方案
    saveScheme: function (flag) {
      // 方案表单验证
      const hasEmpty = this.leaseForm.contractList.find(t => !t.bookingNum === '' || t.hqDeliveryNum === '' || !t.hqShipTo);
      if (hasEmpty) {
        this.$message.error(this.$t('crm_contract_scheme.qjzlfatxwz'));
        return;
      }
      // 附加费不能小于0
      const additionalFee = this.leaseForm.contractList.find(t => +t.additionalFee < 0);
      if (additionalFee) {
        this.$message.error(this.$t('crm_contract_scheme.shfjfbnxy0'));
        return;
      }
      // 商务浮动金额允许为负数，但不能超过甲方代理应收额度。
      const invalidDiscountPrice = this.leaseForm.contractList.find((item) => {
        const discountPrice = this.getNumber(item.discountPrice);
        return discountPrice < -this.getAgentCoProfit(item);
      });
      if (invalidDiscountPrice) {
        this.$message.error(this.$t('crm_contract_scheme.swfdjebndyjfdlysje'));
        return;
      }
      const negativeTotal = this.leaseForm.contractList.find(t => +t.bookingNum <= 0);
      if (negativeTotal) {
        this.$message.error(this.$t('crm_contract_scheme.sbslbnxy0'));
        return;
      }
      const negativeShip = this.leaseForm.contractList.find(t => +t.hqDeliveryNum < 0);
      if (negativeShip) {
        this.$message.error(this.$t('crm_contract_scheme.xzbfhslbnxy0'));
        return;
      }
      const hqDeliveryNumBigger = this.leaseForm.contractList.find(t => +t.bookingNum < +t.hqDeliveryNum);
      if (hqDeliveryNumBigger) {
        this.$message.error(this.$t('crm_contract_scheme.zbfhbxxyzsl'));
        return;
      }

      // 选择方案
      const length = this.leaseForm.contractList.length;
      if (length <= '0') {
        this.$message.error(this.$t('crm_contract_scheme.qing_xuan_ze_fang_an'));
        return;
      }
      // this.form.operateFlag = this.operateFlag;
      this.leaseForm.contractList.forEach((item) => {
        item.operateFlag = this.operateFlag;
        // 期数
        item.periodNum = Math.ceil(item.rentalTerm / item.paymentPeriodSlef);
        // 保存最终租金，租赁金额仍需叠加售后附加费。
        item.discountPrice = this.getNumber(item.discountPrice);
        item.discountAmount = this.getFinalRent(item).toFixed(2);
        item.cost = this.getRentCost(item).toFixed(2);
        // 首期租金/台
        item.firstRent = (item.cost * item.paymentPeriodSlef).toFixed(2);
        // 累计租金/台
        item.totalRent = (item.cost * item.rentalTerm).toFixed(2);
        // 首期租金(合计)
        item.firstRentTotal = parseFloat(item.firstRent * item.bookingNum).toFixed(2);
        // 累计押金
        item.depositFeeTotal = parseFloat(item.depositFee * item.bookingNum).toFixed(2);
        // 首期需支付
        item.firstPay = parseFloat(item.firstRentTotal + item.depositFeeTotal).toFixed(2);
        // item.bizClass = this.contractClass;
        // item.bizId = this.contractId;
      });
      // 保存更改租赁方案
      this.$postJSON(apis.crmContractSaveScheme, {
        bizClass: this.contractClass,
        bizId: this.contractId,
        operateFlag: this.operateFlag,
        goodsList: [...this.leaseForm.contractList, ...this.leaseForm.deleteList],
      }).then((res) => {
        if (res.code === 0) {
          if (flag) {
            this.$message({
              message: this.$t('Common.com_save_success'),
              type: 'success',
            });
            // 上传纸质合同
            this.$emit('success', 5);
          } else {
            this.getCompanyDetail();
          }
        }
      });
    },
    // 新增方案弹窗
    addLeaseItem: function () {
      this.dialogVisible = true;
      this.dialogModel.title = this.$t('crm_contract_scheme.xzzlfa');
      this.dialogModel.rentalTerms = this.contractInfo.signingDuration;
      // 如果是协议订单传协议合同的contractId(contractInfo.contractId)
      // this.dialogModel.bigCustomerId = '514434767445807104';
      if (this.contractInfo.bigCustomerId) {
        this.dialogModel.bigCustomerId = this.contractInfo.bigCustomerId;
      }

      // this.dialogData.schemeType = this.infoForm.schemeType;
      // this.dialogData.currencyUnit = this.infoForm.currencyUnit;
    },
    // 查看分成预览
    onPreviewDialog: function (data) {
      this.dialogModel1.title = this.$t('crm_contract_scheme.fen_cheng_ming_xi');
      this.dialogModel1.data = { row: data, month: data.rentalTerm };
      this.dialogVisible1 = true;
    },
    // 查看违约方案
    onPreviewBreakDialog(data) {
      this.dialogModel2.type = 'watch';
      this.dialogModel2.title = this.$t('crm_contract_scheme.ckwyfa');
      this.dialogModel2.data = { row: data };
      this.dialogVisible2 = true;
    },
    // 选择方案弹窗回调
    // 将非数值统一按 0 处理，避免金额计算出现 NaN。
    getNumber(value) {
      const number = Number(value);
      return Number.isNaN(number) ? 0 : number;
    },
    // 最终租金等于原租金加上商务浮动金额。
    getFinalRent(row) {
      return this.getNumber(row.unitPrice) + this.getNumber(row.discountPrice);
    },
    // 租赁相关金额需要在最终租金基础上叠加售后附加费。
    getRentCost(row) {
      return this.getFinalRent(row) + this.getNumber(row.additionalFee);
    },
    isDiscounted(row) {
      return this.getNumber(row.discountPrice) !== 0;
    },
    // 取当前分成方案中的甲方代理应收/月，作为负数浮动金额的下限。
    getAgentCoProfit(row) {
      const sharingList = row.sharingList || [];
      const sharing = sharingList.find(item => item.sharingClass === row.sharingClass);
      return this.getNumber(sharing && sharing.agentCoProfit);
    },
    // 编辑方案
    editItem: function (item) {
      item.edit = true;
    },
    onRowExpansion: function (item) {
      this.expands = [];
      this.expands.push(item.goodsSkuId);
      item.edit = true;
    },
    // 保存方案
    saveItem: function (item) {
      item.edit = false;
      this.saveScheme(false);
    },
    // 删除方案项
    deleteLeaseItem: function (index, row) {
      this.leaseForm.contractList.splice(index, 1);
      this.leaseForm.deleteList.push({ ...row, isDeleted: true });
      this.schemeInfo = {};
    },
    preStep: function () {
      this.$emit('previous');
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.content-scheme {
  padding: 14px 24px 0;
  .pay-info {
    display: flex;
    justify-content: flex-end;
    line-height: 36px;
    color: #495057;
    font-size: 12px;
    font-weight: 500;
    margin-top: 10px;
    & > div {
      margin-left: 20px;
      margin-right: 10px;
      span {
        color: red;
        font-size: 14px;
      }
    }
  }
  table {
    border-collapse: collapse;
  }
  .el-table .cell {
    // color: #FFFFFF;

    color: rgba(57, 70, 104, 1);
  }
  .el-table .el-table__row td {
    // display: inline-block;
    // width: 100%;
    margin-top: 16px;
    // background: #f5f5fa;
    color: rgba(57, 70, 104, 1);
    border: 0 !important;
  }
  .el-table tr {
    // background: #f5f5fa;
    border: 1px solid #f2f3fb;
    color: rgba(57, 70, 104, 1);
    th .cell {
      color: #636e78;
    }
  }
  .el-table__expanded-cell[class*='cell'] {
    padding: 0;
  }
  .tab-wrap {
    .discount-rent {
      color: #f5222d;
      font-weight: bold;
    }
    // 商务浮动金额使用红色突出显示。
    .discount-price {
      color: #f5222d;
    }
    // 编辑状态下，商务浮动金额输入值使用红色显示。
    .discount-price-input .el-input__inner {
      color: #f5222d;
    }
    // padding: 0 24px;
    .wrap-form {
      background: #ffffff;
      padding: 10px 24px 0;
      .wrap-form-row {
        background: #ffffff;
        padding: 10px 14px 0;
        background: #f8f9fb;
      }
    }
    .rent-amount {
      background: #ffffff;
      padding: 0 8px;
      display: flex;
      li {
        width: 100px;
        margin: 20px 16px 12px;
        border-right: 1px solid rgba(0, 0, 0, 0.05);
        height: 50px;
        .title {
          height: 16px;
          font-size: 12px;
          font-weight: bold;
          color: #495057;
          line-height: 16px;
        }
        .amount {
          margin-top: 6px;
          height: 28px;
          font-size: 12px;
          font-weight: bold;
          color: #0d9ae0;
          line-height: 28px;
        }
        &:last-of-type {
          border: 0;
        }
      }
    }
  }

  .lease-add-btn {
    line-height: 50px;
    text-align: center;
    color: rgba(73, 80, 87, 1);
    font-size: 12px;
    margin: 16px 0 16px;
    height: 50px;
    background: #f6f7fb;
    border: 1px dashed rgba(53, 184, 224, 0.3);
    cursor: pointer;
    span {
      line-height: 50px;
    }
    .icon {
      color: #00afff;
      font-size: 12px;
      margin-right: 8px;
      display: inline-block;
      line-height: 50px;
      height: 50px;
      // float: left;
    }
  }
}
</style>
